"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});let l={};const e=t=>l=t,o=()=>l;exports.getGlobals=o;exports.setGlobals=e;
//# sourceMappingURL=globals.js.map
